import { IFormValues } from './interfaces';

export const DEFAULT_VALUES: IFormValues = {
  title: '',
  cost: '',
  use_global_discounts: false,
  ean: '',
  nds: null,
};
